<template>
    <div class="container">
        <el-card class="box-card" v-loading.body="loading">
            <div slot="header" class="clearfix">
                <span style="line-height: 36px;">最新公告</span>
                <i class="iconfont icon-new1"></i>
            </div>
            <div v-for="item in tableData" :key="item.id" class="item">
                <router-link :to="`/dashboard/noticeDetail/${item.id}`">{{item.title}}</router-link>
                <span class="fr">{{item.create_time}}</span>
            </div>
            <div v-if="tableData.length == 0">还没有公告哦~</div>
        </el-card>
        <!--<el-row class="mb15">-->
            <!--<blockquote class="elem-quote">-->
                <!--<p>最新公告<i class="iconfont icon-new1"></i></p>-->
            <!--</blockquote>-->
        <!--</el-row>-->
        <!--&lt;!&ndash;table&ndash;&gt;-->
        <!--<el-table-->
                <!--v-loading="loading"-->
                <!--:data="tableData"-->
                <!--:show-header="false"-->
                <!--style="width: 100%">-->
            <!--<el-table-column-->
                    <!--prop="title"-->
                    <!--label=""-->
                    <!--width="">-->
                <!--<template slot-scope="scope">-->
                    <!--<router-link :to="`/dashboard/noticeDetail/${scope.row.id}`">{{scope.row.title}}</router-link>-->
                <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column-->
                    <!--prop="create_time"-->
                    <!--label=""-->
                    <!--width="200">-->
            <!--</el-table-column>-->
        <!--</el-table>-->
    </div>
</template>

<script>
    export default {
        name: 'notice',
        computed: {

        },
        data() {
            return{
                tableData: [],
                loading: true
            }
        },
        created (){
            //获取公告列表
            this.$api.post(this.$apiUrl.systemNotice,{},(res)=>{
                this.loading = false;
                this.tableData = res.data || [];
            },()=>{
                this.loading = false;
            })
        }
    }
</script>
<style lang="scss"  scoped>
    .item {
        padding: 18px 0;
        border-bottom: 1px dashed #dfe6ec;
        &:last-child{
            border-bottom: none;
        }
    }
    .iconfont{
        color: #ff0000;
    }
</style>


// WEBPACK FOOTER //
// notice.vue?6f63ec8a